var map = {
	"./integrations-helpers": "d9g+",
	"./integrations-helpers.js": "d9g+",
	"./test-integrations": "UHV5",
	"./test-integrations.js": "UHV5",
	"./total-rewards-integrations": "3BIG",
	"./total-rewards-integrations.js": "3BIG"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DVmf";